/**
 * Метрики app shell для JS (отступ контента под сайдбар и т.п.).
 * Fallback до чтения getComputedStyle(document.documentElement) — должны совпадать
 * с `--sidebar-width-expanded` / `--sidebar-width-collapsed` в `STYLESYSTEM/layout/sidebar.css`
 * (:root; на экранах >1920px в том же файле — 256px / 68px, подхватывается через CSS).
 */
export const LAYOUT_SIDEBAR_EXPANDED_FALLBACK_PX = 240;
export const LAYOUT_SIDEBAR_COLLAPSED_FALLBACK_PX = 64;
